import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import baseapi from '../../base/baseapi.json';

@Injectable({
  providedIn: 'root',
})
export class ElectricityBillServiceIN {
  constructor(private http: HttpClient) {}
  getHeader(): any {
    return new HttpHeaders()
      .set('enctype', 'multipart/form-data')
      .set('Accept', 'application/json');
  }
  getEBilDatasForIN(
    country: any,
    pincode: any,
    averageMonthlyElectricityBill: any
  ): any {
    return this.http.get(baseapi.getDatas, {
      params: { country, pincode, averageMonthlyElectricityBill },
      headers: this.getHeader(),
      observe: 'response',
    });
  }
  getEBilUnitsDatasForIN(
    country: any,
    pincode: any,
    editUnits: any,
    averageMonthlyElectricityBill: any
  ): any {
    return this.http.get(baseapi.getEditedUnitsData, {
      params: {
        country,
        pincode,
        editUnits,
        averageMonthlyElectricityBill,
      },
      headers: this.getHeader(),
      observe: 'response',
    });
  }

  editPVSizeForIN(
    country: any,
    pincode: any,
    pvSize: any,
    averageMonthlyElectricityBill: any
  ): any {
    return this.http.get(baseapi.getDataForEditPVSize, {
      params: {
        country,
        pincode,
        pvSize,
        averageMonthlyElectricityBill,
      },
      headers: this.getHeader(),
      observe: 'response',
    });
  }
}
